import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { LocaleComponentNgModule } from '../locale/module';
import { ProductActionDirective } from './product-action.directive';
export var ProductActionComponentNgModule = module(baseModuleId + ".product-action", [LocaleComponentNgModule.name])
    .directive('productAction', ProductActionDirective);
